"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullCache = exports.MemoryCache = void 0;
var memoryCache_1 = require("./memoryCache");
Object.defineProperty(exports, "MemoryCache", { enumerable: true, get: function () { return memoryCache_1.MemoryCache; } });
var nullCache_1 = require("./nullCache");
Object.defineProperty(exports, "NullCache", { enumerable: true, get: function () { return nullCache_1.NullCache; } });
//# sourceMappingURL=index.js.map